export default "__VITE_ASSET__yvjn9pPI__"